import qs from 'qs';
import ApiResourceManager from '../ApiResourceManager';

/**
 * Reaches the agent ops queue through shop-backend's dashboard API
 * (/dashboard/agent/ops-queue) — the same host + SSO auth as everything else.
 * shop-backend is the gateway: it authenticates the manager, enforces the
 * company ACL, and proxies to the agent-ops control core. The client is
 * unaware that agent-ops exists as a separate service.
 */
export default class OpsQueueManager extends ApiResourceManager {
  list = (params) =>
    this.request({
      method: 'GET',
      url: '/agent/ops-queue',
      params,
      paramsSerializer: qs.stringify,
    });

  show = (id) =>
    this.request({
      method: 'GET',
      url: `/agent/ops-queue/${id}`,
    });

  confirm = (id, data = {}) =>
    this.request({
      method: 'POST',
      url: `/agent/ops-queue/${id}/confirm`,
      data,
    });

  reject = (id, note) =>
    this.request({
      method: 'POST',
      url: `/agent/ops-queue/${id}/reject`,
      data: { note },
    });

  // Generate a new revision of a suggestion from a free-text instruction.
  createRevision = (id, prompt, fromRevision = null) =>
    this.request({
      method: 'POST',
      url: `/agent/ops-queue/${id}/revisions`,
      data: fromRevision === null ? { prompt } : { prompt, from_revision: fromRevision },
    });
}
